// https://vuex.vuejs.org/en/getters.html
import i18n from '@/i18n'

export default {
  // todo: Remove this, this should not be neccesary once the api is working
  getCustomerName: state => customerUid => {
    var customer = state.data.find(c => {
      return c.uid === customerUid
    })
    return !customer ? i18n.t('General.Labels.UnknownEntity', ['customer']) : customer.name
  },
}
